import Container from 'typedi';
import {
    EventFormatterBuilderFactory,
    EventFormatterType,
} from '@888unifiedclient/event-formatter';
import { WindowToken } from '../../../../injection-tokens';
import { TrackingContext } from '../../../tracking/models/trackingContext';
import { TrackingUtilsService } from '../../../tracking/tracking-utils.service';
import LogIndex from '../../../tracking/enums/LogIndex';

export const registerEventFormatting = (): void => {
    const window = Container.get(WindowToken);
    const trackingContext = Container.get(TrackingContext);
    const trackingUtilsService = Container.get(TrackingUtilsService);
    const { versionNumber, buildNumber } = window.pageContextManager.getReleaseData();
    const { ipAddressV6, ipAddress } = window.pageContextManager.getNetworkData();
    const { serverName, systemId, environment } = window.pageContextManager.getEnvironmentData();

    const logFormatterBuilderFactory = new EventFormatterBuilderFactory({
        sender: {
            ipv4: ipAddress,
            ipv6: ipAddressV6,
            serverName: serverName,
            systemID: systemId,
            buildNumber: buildNumber,
            versionNumber: versionNumber,
        },
        type: EventFormatterType.Client,
        settings: {
            environment: environment?.toLowerCase(),
            target: LogIndex.UnifiedClient,
            sessionID: trackingContext.getUcSessionCorrelationId(),
        },
        sessionData: trackingUtilsService.getLogV2SessionData(),
        userData: trackingUtilsService.getLogV2UserData(),
    });

    Container.set(EventFormatterBuilderFactory, logFormatterBuilderFactory);
};
